import React from 'react'
import { Button, Flex, Spacer, useColorModeValue } from '@chakra-ui/react'
import { useNavigate } from '@reach/router'
import { FormInput } from 'components/Common/InputPageComponent/FormInput'
import { FormTextarea } from 'components/Common/InputPageComponent/FormTextarea'
import { FormUploadImage } from 'components/Common/InputPageComponent/FormUploadImage'

type Props = {
  onNext: () => void
  requiredValue: string
  isValid: boolean
}

export const FirstInputPage: React.FC<Props> = ({
  onNext,
  requiredValue,
  isValid,
}) => {
  const navigate = useNavigate()
  const buttonNextColor = useColorModeValue('buttonNextLight', 'buttonNextDark')
  const buttonBackColor = useColorModeValue('buttonBackLight', 'buttonBackDark')
  return (
    <Flex direction="column">
      <Flex w="100%" pb="5">
        <Button
          variant="outline"
          aria-label="Delete Quiz"
          backgroundColor={buttonBackColor}
          onClick={() => navigate('/quizplaylist')}
        >
          リスト一覧へ戻る
        </Button>
        <Spacer />
        <Button
          variant="outline"
          aria-label="Delete Quiz"
          backgroundColor={buttonNextColor}
          onClick={onNext}
          // isValidは初回ロード時isRequired未入力の時Trueでボタンのdisabledができない。valuesのnameを検知することで、初回ロード時にdisabledできるようにしている。
          disabled={!isValid || !requiredValue}
        >
          次へ
        </Button>
      </Flex>
      <FormUploadImage name="imageUrl" />
      <FormInput name="name" label="リストの名前" isRequired={true} />
      <FormTextarea name="description" label="リストの説明" />
      <FormInput name="snsInfo.shareText" label="SNS投稿文" />
      <FormInput name="snsInfo.destinationLink" label="遷移先リンク" />
      <FormInput
        name="snsInfo.destinationLinkText"
        label="遷移先リンクの説明"
      />
    </Flex>
  )
}
